module.exports = __webpack_public_path__ + "static/img/5.f4c4711.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/5.png
// module id = xzdn
// module chunks = 0